import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Fx, Stack } from 'Components';
import { useStores } from 'Hooks/useStore';
import { DashboardContext } from 'Pages/Dashboard/DashboardContext';
import DashboardFilters from 'Pages/Dashboard/DashboardFilters/DashboardFilters';
import { DashboardFiltersValues } from 'Pages/Dashboard/Dashboard.types';
import { getAppRoutes } from 'Pages/App/App.constants';
import { UserActivity, Elearning } from '.';
import HeaderRow from 'Pages/NewDashboard/components/HeaderRow';
import Courses from 'Pages/Courses';
import Standard from 'Pages/Reports/Standard/Standard';
import Saved from 'Pages/Reports/Saved/Saved';

function ReportPage() {
	const stores = useStores();
	const { authStore } = stores;
    const isSuperAdmin = authStore.isCurrentUserSuperAdmin;
	const [filterValues, setFilterValues] = useState<DashboardFiltersValues>({});
	const { pathname } = useLocation();
	const [hasProperties, setHasProperties] = useState(true);
	const appRoutes = getAppRoutes();

	const onDashboardFiltersChange = (value: DashboardFiltersValues) => {
		setFilterValues({ ...filterValues, ...value });
	};

	useEffect(() => {
        return () => stores.clearDashboardStore();
    }, []);

	let componentDetails = null;
	if (appRoutes.USER_ACTIVITY === pathname) {
		componentDetails = {
			title: "User Activity",
			subTitle: "Monitor user activity and account statistics.",
			showFilter: true,
			component: <UserActivity />
		}
	} else if (appRoutes.TRAINING === pathname) {
		componentDetails = {
			title: "Training",
			subTitle: "Analyze training completion and progress.",
			showFilter: true,
			component: <Elearning />
		}
	} else if(appRoutes.COURSES === pathname) {
		componentDetails = {
			title: "Courses",
			subTitle: "A quick overview of your assigned training and progress.",
			showFilter: isSuperAdmin,
			component: <Courses />
		}
	} else if(appRoutes.REPORTS === pathname) {
		componentDetails = {
			title: "Library",
			subTitle: "Browse available report templates.",
			showFilter: false,
			component: <Standard />
		}
	} else if(appRoutes.SAVED_REPORTS === pathname) {
		componentDetails = {
			title: "Saved",
			subTitle: "Access your saved reports.",
			showFilter: false,
			component: <Saved />
		}
	}

	return (
		<DashboardContext.Provider value={{ filters: filterValues, hasProperties }}>
			<Fx fullHeight>
				<Fx column grow={1}>
					<Stack>
						<HeaderRow title={componentDetails?.title || ""} subHeading={componentDetails?.subTitle || ""}>
							{componentDetails?.showFilter && <DashboardFilters key={pathname} onChange={onDashboardFiltersChange} onSetHasProperties={setHasProperties} />}
						</HeaderRow>
						{componentDetails?.component || null}
					</Stack>
				</Fx>
			</Fx>
		</DashboardContext.Provider>
	);
}

export default ReportPage;